import { Button, ColourStateSolid } from '@ukpostbox/frontend-framework';
import { Controller, useFormContext } from '@ukpostbox/frontend-framework/lib/ReactHookForm';
import React from 'react';

type IncludeExcludeType = {
	name: string;
	defaultValue: boolean;
};

function IncludeExclude(props: IncludeExcludeType) {
	const { control, getValues } = useFormContext();

	return (
		<Controller
			control={control}
			name={props.name}
			defaultValue={props.defaultValue}
			render={({ field, fieldState }) => (
				<div className='btn-group m-0'>
					<Button
						title='Includes'
						fullWidth
						onClick={() => field.onChange(true)}
						colour={getValues(props.name) ? ColourStateSolid.Selected : ColourStateSolid.Secondary}
					/>
					<Button
						title='Excludes'
						fullWidth
						onClick={() => field.onChange(false)}
						colour={!getValues(props.name) ? ColourStateSolid.Selected : ColourStateSolid.Secondary}
					/>
				</div>
			)}
		/>
	);
}

export { IncludeExclude };
